import { union } from "lodash";
import * as z from "zod";

export const ItemModSchema = z.object({
  id: z.string(),
  itemModId: z.string(),
  name: z.string(),
  salesPriceTaxInclusive: z.coerce.number(),
  modType: z.union([z.literal("mandatory"), z.literal("optional")]),
  salesPriceId: z.string(),
  itemModGroupId: z.string(),
});
export type ItemMod = z.infer<typeof ItemModSchema>;

export const CartItemSchema = z.object({
  id: z.string(),
  totalSalesPriceTaxInclusive: z.coerce.number(),
  itemName: z.string(),
  multiplier: z.coerce.number(),
  itemId: z.string(),
  salesPriceId: z.string(),
  itemMods: z.array(ItemModSchema),
  itemHeroImageUrl: z.string().nullish(),
});
export type CartItem = z.infer<typeof CartItemSchema>;
export const CartStatusesSchema = z.union([
  z.literal("pending"),
  z.literal("completed"),
  z.literal("cancelled"),
]);
export type CartStatus = z.infer<typeof CartStatusesSchema>;

export const CartSchema = z.object({
  uuid: z.string(),
  createdAt: z.string().nullish(),
  name: z.string().nullish(),
  floorTableId: z.string().nullish(),
  venueId: z.string(),
  customerTabId: z.string().nullish(),
  items: z.array(CartItemSchema),
  orderNumber: z.union([z.string(), z.number()]).nullish(),
  orderId: z.string().nullish(),
  pickUpAt: z.string().nullish(),
  pickUpInMinutes: z.number().nullish(),
  status: CartStatusesSchema,
});
export type Cart = z.infer<typeof CartSchema>;

export const SoldOutItemsErrorSchema = z.object({
  soldOutItemsUuids: z.array(z.string()),
  error: z.literal("items_sold_out"),
  message: z.string(),
});
export const GenericErrorSchema = z.object({
  error: z.literal("error").catch("error"),
  message: z.string().catch("Something went wrong"),
});

export const CheckoutErrorSchema = z
  .discriminatedUnion("error", [SoldOutItemsErrorSchema, GenericErrorSchema])
  .catch(
    GenericErrorSchema.parse({
      error: "Caught Unknown Error",
      message: "Something went wrong",
    }),
  );
